<tt-page>
    <tt-webpagemenu [ttName]="name"></tt-webpagemenu>
</tt-page>
